import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles, Typography, Button } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import { POI_ACTION_TYPES } from '../../redux-saga/actionTypes';
import styles from './styles';

const Ratings = ({ classes, t, filterListEvent, criteriaList }) => {
  const selectedButton = classes.any__button;
  const notSelectedButton = classes.rating__button;
  const anyText = classes.any__text;
  const rating = classes.rating__text;
  const starNotSelected = classes.star__rated;
  const starSelected = classes.star__rated__white;
  const [selectedValue, setSelectedValue] = React.useState(
    criteriaList.rating === undefined ? '*' : criteriaList.rating,
  );

  const handleSelectedIndex = value => {
    setSelectedValue(value);
    filterListEvent({ criteriaName: 'rating', value });
  };

  const list = [
    { rating: t('filter.label.action-button.any'), stars: '*' },
    { rating: '2.0', stars: 2 },
    { rating: '3.0', stars: 3 },
    { rating: '4.0', stars: 4 },
    { rating: '5.0', stars: 5 },
  ];

  return (
    <React.Fragment>
      <span className={classes.container}>
        <span className={classes.title__container}>
          <Typography className={classes.title}>{t('filter.label.rating')}</Typography>
          <Typography className={classes.subtitle}>{t('filter.label.at-least')}</Typography>
        </span>
        <span className={classes.scroll__wheel}>
          {list.map((value, index) => (
            <Button
              onClick={() => handleSelectedIndex(value.stars)}
              className={selectedValue === value.stars ? selectedButton : notSelectedButton}
            >
              <span className={classes.rating__wrapper}>
                <Typography className={selectedValue === value.stars ? anyText : rating}>
                  {value.rating}
                </Typography>
                {index === 0 ? null : (
                  <Rating
                    className={selectedValue === value.stars ? starSelected : starNotSelected}
                    readOnly
                    value={value.rating}
                  />
                )}
              </span>
            </Button>
          ))}
        </span>
      </span>
    </React.Fragment>
  );
};

Ratings.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  filterListEvent: PropTypes.func.isRequired,
  criteriaList: PropTypes.object.isRequired,
};

const mapStateToProps = ({ poi }) => ({
  criteriaList: poi.filter_criteria_list,
});

const mapDispatchToProps = dispatch => ({
  filterListEvent: payload => dispatch({ type: POI_ACTION_TYPES.FILTER.SET, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(Ratings)),
);
